import type { GetAdminAccountUsageResponse } from '@kyumo/common';

/**
 * アカウント別の月間利用額 CSV
 *
 * 所属部門ごとの集計は、この CSV を手元で名簿と突き合わせて行う前提。
 * そのため利用額は丸めない（部門で合計したときに丸め誤差が積み上がるのを避ける）。
 */

const HEADER = ['対象月', 'メールアドレス', 'リクエスト数', '合計トークン数', '利用額(USD)'];

/** Excel が UTF-8 と判定できるよう先頭に付ける */
const UTF8_BOM = '﻿';

/**
 * 1 セルをエスケープする（RFC 4180）
 *
 * 表計算ソフトで式として解釈される先頭文字（= + - @ など）は ' を前置して
 * 文字列として扱わせる
 */
function escapeCell(value: string | number): string {
  let text = String(value);
  if (typeof value === 'string' && /^[=+\-@\t\r]/.test(text)) {
    text = `'${text}`;
  }
  if (/[",\r\n]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

/**
 * CSV 本文を組み立てる（BOM は含めない）
 */
export function buildAccountUsageCsv(data: GetAdminAccountUsageResponse): string {
  const rows = [
    HEADER,
    ...data.users.map((u) => [data.month, u.email, u.requestCount, u.totalTokens, u.cost]),
  ];
  return `${rows.map((row) => row.map(escapeCell).join(',')).join('\r\n')}\r\n`;
}

export function accountUsageCsvFileName(month: string): string {
  return `usage-by-account-${month}.csv`;
}

/**
 * CSV をファイルとしてダウンロードさせる
 */
export function downloadAccountUsageCsv(data: GetAdminAccountUsageResponse): void {
  const blob = new Blob([UTF8_BOM, buildAccountUsageCsv(data)], {
    type: 'text/csv;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = accountUsageCsvFileName(data.month);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 100);
}
